import { ZendeskArticle } from '../../../../tw/models/ZendeskArticle'
import React from 'react'

const FAQDetailsHeading = ({ article }: { article: ZendeskArticle }) => {
	return (
		<div className="text-24 text-latoBold mb-8" data-testid="faq-heading">
			{article.displayLabel()}
		</div>
	)
}

export default FAQDetailsHeading
